<template>
  <div class="login-page">
    <div class="login-page__bg">
      <div class="login-page__shape login-page__shape--1"></div>
      <div class="login-page__shape login-page__shape--2"></div>
    </div>

    <div class="login-card">
      <div class="login-card__brand">
        <img alt="logo" class="login-card__logo" src="@/assets/logo2.png">
        <h1 class="login-card__title">互联天下</h1>
        <p class="login-card__subtitle">代理商后台管理系统</p>
      </div>

      <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="rules"
          class="login-card__form"
          label-position="top"
          @keyup.enter.native="handleLogin"
      >
        <el-form-item label="用户名" prop="name">
          <el-input v-model="loginForm.name" placeholder="请输入用户名" prefix-icon="el-icon-user"/>
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-input v-model="loginForm.pwd" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password/>
        </el-form-item>
        <div class="login-card__options">
          <el-checkbox v-model="rememberMe">记住我</el-checkbox>
        </div>
        <el-button
            :loading="loading"
            class="login-card__submit"
            type="primary"
            @click="handleLogin"
        >
          登 录
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {online} from "@/utils/websocket/websocket";

const REMEMBER_KEY = 'login_remember'
const NAME_KEY = 'login_name'
const PWD_KEY = 'login_pwd'

export default {
  name: 'Login',
  data: () => {
    return {
      rules: {
        name: [
          {required: true, message: '请输入用户名'},
        ],
        pwd: [
          {required: true, message: '请输入密码'},
        ]
      },
      loginForm: {
        client_id: 'agency',
        client_secret: 'agency',
        grant_type: 'agency',
        name: '',
        pwd: ''
      },
      rememberMe: false,
      loading: false,
      passwordType: 'password',
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['socket',]),
  },
  created() {
    this.loadRememberedCredentials()
  },
  methods: {
    ...mapActions({
      login: 'login',
      setSocket: 'setSocket',
      setOnlineState: 'setOnlineState',
      setOnlineDisabled: 'setOnlineDisabled',
      setAutoReconnect: 'setAutoReconnect',
      clearHistoryMessage: 'clearHistoryMessage',
      addToHistoryMessage: 'addToHistoryMessage',
    }),
    loadRememberedCredentials() {
      if (localStorage.getItem(REMEMBER_KEY) !== '1') {
        return
      }
      this.rememberMe = true
      this.loginForm.name = localStorage.getItem(NAME_KEY) || ''
      this.loginForm.pwd = localStorage.getItem(PWD_KEY) || ''
    },
    persistRememberCredentials() {
      if (this.rememberMe) {
        localStorage.setItem(REMEMBER_KEY, '1')
        localStorage.setItem(NAME_KEY, this.loginForm.name)
        localStorage.setItem(PWD_KEY, this.loginForm.pwd)
        return
      }
      localStorage.removeItem(REMEMBER_KEY)
      localStorage.removeItem(NAME_KEY)
      localStorage.removeItem(PWD_KEY)
    },
    handleLogin() {
      this.$refs["loginForm"].validate((valid) => {
        if (!valid) {
          return false
        }
        this.persistRememberCredentials()
        this.loading = true
        this.login(this.loginForm).then(() => {
          this.$router.push({path: this.redirect || '/'})
          this.loading = false
          this.setAutoReconnect(true)
          online(this, this.socket)
        }).catch(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%);

  &__bg {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
  }

  &__shape {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.35;

    &--1 {
      width: 480px;
      height: 480px;
      background: #1677ff;
      top: -120px;
      right: -80px;
    }

    &--2 {
      width: 360px;
      height: 360px;
      background: #4096ff;
      bottom: -80px;
      left: -60px;
    }
  }
}

.login-card {
  position: relative;
  z-index: 1;
  width: 420px;
  max-width: calc(100vw - 32px);
  padding: 40px 36px 36px;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.25);

  &__brand {
    text-align: center;
    margin-bottom: 32px;
  }

  &__logo {
    width: 56px;
    height: 56px;
    border-radius: 12px;
  }

  &__title {
    margin: 16px 0 0;
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    letter-spacing: 2px;
  }

  &__subtitle {
    margin: 6px 0 0;
    font-size: 14px;
    color: #9ca3af;
  }

  &__form {
    ::v-deep .el-form-item__label {
      padding-bottom: 6px;
      line-height: 1.4;
      color: #4b5563;
    }

    ::v-deep .el-input__inner {
      height: 44px;
      line-height: 44px;
      border-radius: 8px;
    }

    ::v-deep .el-input__prefix {
      left: 12px;
      color: #c0c4cc;
    }

    ::v-deep .el-input--prefix .el-input__inner {
      padding-left: 38px;
    }
  }

  &__options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: -4px 0 12px;

    ::v-deep .el-checkbox__label {
      color: #6b7280;
    }
  }

  &__submit {
    width: 100%;
    height: 44px;
    margin-top: 8px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 4px;
    border-radius: 8px;
    background: #1677ff;
    border-color: #1677ff;

    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}
</style>
